module.exports = __webpack_public_path__ + "img/bg-system1.d5df6ace.png";